import './App.css';
import { useState, useEffect } from 'react';

const Recovery = () => {
    const [vendors, setVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch('/vendor_list.json')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch vendor list (${response.status})`);
                }
                return response.json();
            })
            .then(data => {
                setVendors(data);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error loading vendor list:', err);
                setError(err.message);
                setLoading(false);
            });
    }, []);

    return (
        <>
            <div className='h-20'></div>
            <div className='heading-rounded m-auto text-center text-white font-bold py-4 w-11/12 md:w-3/5'>Recovery Agents</div>
            <section>
                <div className='container px-6 xl:px-0 xl:w-4/5 2xl:container mx-auto py-20 min-h-screen flex flex-col justify-center'>
                    <p className='text-2xl'>
                        List of authorised recovery agency(ies)/agent(s), resolution agency(ies)/agent(s), collection agency(ies)/agent(s):
                    </p>
                    <div className='overflow-x-auto w-full max-h-[50rem] overflow-y-scroll mt-16'>
                        {loading ? (
                            <p>Loading...</p>
                        ) : error ? (
                            <p className='text-red-600'>Unable to load vendor list. Please try again later.</p>
                        ) : !vendors.length ? (
                            <p>No vendors found.</p>
                        ) : (
                            <table className="table-auto recovery-agent ">
                                <thead>
                                    <tr>
                                        <th className='lg:min-w-[250px] '>Agency Code</th>
                                        <th className='min-w-[250px]'>Name of agency</th>
                                        <th className='min-w-[300px]'>Email</th>
                                        <th className='min-w-[300px]'>address</th>
                                        <th className='min-w-[300px]'>Contact</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vendors.map((vendor, index) => (
                                        <tr key={index} className={index % 2 === 1 ? 'bg-alt' : ''}>
                                            <td>{vendor.agencyCode}</td>
                                            <td>{vendor.nameOfAgency}</td>
                                            <td>{vendor.email}</td>
                                            <td>{vendor.address}</td>
                                            <td>{vendor.contact}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </section>
        </>
    )
}
export default Recovery
